import * as React from "react";
const SvgWasherSm = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M21 1H3V23H21V1Z",
	stroke: "#745BA3",
	strokeOpacity: .87,
	strokeWidth: 2,
	strokeLinecap: "square"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18 4L15 4",
	stroke: "#745BA3",
	strokeOpacity: .87,
	strokeWidth: 2,
	strokeLinecap: "square"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.2 17.8008C8.7 18.6253 10.35 19 12 19C13.65 19 15.3 18.5503 16.8 17.8008C17.625 16.3018 18 14.6529 18 13.004C18 11.3552 17.55 9.70627 16.8 8.20728C15.3 7.38283 13.65 7.00809 12 7.00809C10.35 6.93314 8.7 7.38283 7.2 8.20728C6.375 9.70627 6 11.3552 6 13.004C6 14.6529 6.375 16.3018 7.2 17.8008Z",
	stroke: "#745BA3",
	strokeOpacity: .87,
	strokeWidth: 2,
	strokeLinecap: "square"
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 12,
	cy: 13,
	r: 3,
	stroke: "#745BA3",
	strokeOpacity: .87,
	strokeWidth: 2,
	strokeLinecap: "square"
}));
export default SvgWasherSm;
